import { UserRoleUI } from "../contexts/AuthContext";

export type DefaultAuthRoute = "Admin" | "Admin Dashboard" | "Companion Home" | "Home";

export const getDefaultAuthenticatedRoute = ({
  userRole,
  isCompanionMode,
}: {
  userRole: UserRoleUI;
  isCompanionMode: boolean;
}): DefaultAuthRoute => {
  // if (userRole === UserRoleUI.ADMIN) {
  //   return "Admin";
  // }

  if (userRole !== UserRoleUI.STUDENT) {
    return "Admin Dashboard";
  }

  return isCompanionMode ? "Companion Home" : "Home";
};
